const inr = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const inr0 = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
const int = new Intl.NumberFormat('en-IN');

/** ₹ crore amount: two decimals, whole crores from ₹100 Cr up. Net redemptions show as −₹x Cr. */
export const cr = (v: number): string => {
  const abs = Math.abs(v);
  const s = '₹' + (abs >= 100 ? inr0 : inr).format(abs) + ' Cr';
  return v < 0 && s !== '₹0.00 Cr' ? '−' + s : s;
};

/** Percentages use a true minus, matching the −₹ amounts. */
const signed = (s: string): string => (s.startsWith('-') && !/^-0(\.0)?%$/.test(s) ? '−' + s.slice(1) : s.replace(/^-/, ''));

export const pc = (v: number): string => signed(`${Math.round(v * 100)}%`);

export const pc1 = (v: number): string => signed(`${(v * 100).toFixed(1)}%`);

export const count = (v: number): string => int.format(v);

export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || '·';
